// eslint-disable-next-line import/prefer-default-export
export const VISIBILITY_FILTERS = {
  ALL: 'all',
  COMPLETED: 'completed',
  INCOMPLETE: 'incomplete',
};

export const MULTI_PART_FILE_SIZE = 500 * 1024 * 1024;
// export const MULTI_PART_FILE_SIZE = 0;

export const MULTI_PART_FILE_CHUNK_SIZE = 55 * 1024 * 1024;
// export const MULTI_PART_FILE_CHUNK_SIZE = 1024 * 1024;

export const DESIGN_PATH_CHARACTER_LIMIT_FOLDER = 140;
export const DESIGN_PATH_CHARACTER_LIMIT_FILE = 160;

/** Folder icon fill, matching the yellow Windows Explorer uses for folders. */
export const FOLDER_ICON_COLOR = '#FFC107';

/**
 * Stands in for the project name at the root of a default folder structure, for the subscriber
 * admin dashboard, where the structure is not tied to one project yet.
 */
export const PROJECT_NAME_PLACEHOLDER = 'Project Name';

// Placeholder options for the Potential Change Order "Reason for Change" field.
// Multi-select; stored on the document as a string[] (reasonForChange).
export const REASON_FOR_CHANGE_OPTIONS = [
  'Owner Change',
  'Design Issue',
  'Unforeseen Condition',
  'Regulatory Requirement',
  'Construction Impact',
];
